import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysUntil',
  standalone: false,
  pure: false,
})
export class DaysUntilPipe implements PipeTransform {
  transform(
    targetDate: string | Date | undefined
  ): number {
    if (!targetDate) return -1;

    const now = new Date();
    const target = new Date(targetDate);

    const utcNow = Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate()
    );
    const utcTarget = Date.UTC(
      target.getUTCFullYear(),
      target.getUTCMonth(),
      target.getUTCDate()
    );

    const msPerDay = 24 * 60 * 60 * 1000;
    return Math.ceil((utcTarget - utcNow) / msPerDay);
  }
}
